import React from "react";

import { Tags, Tag, TagTitle, InputTags, Container, DocumentType, Line } from "./styles"
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import Icon from "components/Icon";
import { isArray } from "lodash-es";
import Colors from "../../constants/Colors";

import FitinsurAPI from '../../utils/src/fitinsur-api'

const TagsList = ({
    hideTrash,
    disableType,
    tags,
    disabled,
    removeTag,
    customColor,
    labelDescription = null,
    idOperation = null,
    contextApp = null,
    expireDocumentOnRemove = false,
    updateIsLoadingStatus
}) => {
    if (!isArray(tags)) tags = [];

    function expireDocument(idDocument) {
        if (!idOperation || !idDocument || !contextApp || !expireDocumentOnRemove) return;
        updateIsLoadingStatus(true);

        const fitinsur = new FitinsurAPI();

        fitinsur.setAuthToken(contextApp.token);
        fitinsur.requestExpireDocument(Number(idOperation), idDocument)
            .then((data) => console.log(data))
            .catch((error) => console.log(error))
            .finally(() => updateIsLoadingStatus(false));
    };

    return (
        <Container>
            {tags?.length ? <Line /> : ''}

            {tags?.map((tag, index) => {
                if (tag.deleteAttachment) return <></>

                return (<Tags key={index}>
                    {!disableType ?
                        <Col md={tag.periodicity ? 3 : 6} sm={12} xs={12}>
                            <DocumentType>
                                {labelDescription ? `${labelDescription} - ${tag?.documentType?.dsAnswerOption}` : tag?.documentType?.dsAnswerOption}
                            </DocumentType>
                        </Col> : ""}
                    {(!disableType && tag.periodicity) ?
                        <Col md={3} sm={12} xs={12}>
                            <DocumentType>
                                {tag.periodicity}
                            </DocumentType>
                        </Col> : ""}
                    <Col md={!disableType ? 6 : 12} sm={7} xs={8}>
                        <Row>
                            <Col md={11} >

                                <Tag backgroundColor={customColor}>
                                    <TagTitle href={tag.fileUrl} target="_blank">
                                        {tag.fileName}
                                    </TagTitle>
                                </Tag>
                            </Col>
                            <Col md={1} style={{ padding: "0px 0px 0px 0px", direction: "rtl" }}>
                                {!disabled &&
                                    <Icon
                                        name="trash"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            removeTag(index)
                                            if (idOperation && expireDocumentOnRemove) {
                                                expireDocument(tag.documentId)
                                            }
                                        }}
                                    />
                                }
                            </Col>
                        </Row>
                    </Col >
                    <Line />
                </Tags >)
            })}
        </Container >
    );
};
export default TagsList;